module.exports = __webpack_public_path__ + "img/sgh_icon.596d9dd8.png";